import { createContext } from 'react';

export const MakerContext = createContext(null);